module.exports = __webpack_public_path__ + "media/entities/1208-0be8278f.png";